module.exports = __webpack_public_path__ + "static/media/Sustainability-Focused Company.6e960cd1.webp";